import script from "./WidgetDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetDisplay.vue?vue&type=script&setup=true&lang=js"

import "./WidgetDisplay.vue?vue&type=style&index=0&id=7c462c11&lang=css"

const __exports__ = script;

export default __exports__